import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthCtx = createContext({
  user: null, loading: true,
  loginWithVipps: () => {}, logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const loginWithVipps = async () => {
    try {
      const res = await api.get("/auth/vipps/login");
      window.location.href = res.data.url;
    } catch (err) {
      console.error("Vipps login error", err);
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthCtx.Provider value={{
      user, loading,
      loginWithVipps, logout,
      refresh: checkAuth, setUser,
    }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
